import React from "react";
import { Link } from "react-router-dom";
import pagenotfoundImage from "../assets/pagenotfound.png";
import "./PageNotFound.css";
import MovingComponent from "react-moving-text";
import Footer from "../Footer/Footer";
import Nav from "../Nav";
import Navbar from "../Navbar";

const PageNotFound = () => {
  return (
    <div>
      <Nav />
      <Navbar />
      <div className="pageNotFound pt-4">
        <MovingComponent
          type="jelly"
          duration="1000ms"
          delay="0s"
          direction="alternate"
          timing="ease-in-out"
          iteration="infinite"
          fillMode="both"
        >
          <h1
            style={{
              color: "red",
              fontSize: "16px",
              fontWeight: "bold",
              marginTop: "10px",
            }}
          >
            Oops..! 404 Page Not Found
          </h1>
        </MovingComponent>
        <p
          style={{
            color: "black",
            fontSize: "22px",
            fontWeight: "bold",
            textAlign: "center",
          }}
        >
          Looks like you came to the wrong page on our server
        </p>
        <p
          style={{
            color: "#1e7320",
            fontSize: "34px",
            fontWeight: "bold",
            textAlign: "center",
          }}
        >
          KIPPRA CONFERENCE
        </p>
        <MovingComponent
          type="fadeInFromLeft"
          duration="2000ms"
          delay="0s"
          direction="normal"
          timing="ease"
          iteration="1"
          fillMode="none"
        >
          <img
            className="image404"
            src={pagenotfoundImage}
            height="500"
            width="500"
            alt="not found"
            style={{ marginLeft: "auto", marginRight: "auto" }}
          />
        </MovingComponent>
        <Link className="link" to="/">
          Go back to the home page
        </Link>
      </div>
      <div style={{ marginTop: "20px" }}>
        <Footer />
      </div>
    </div>
  );
};

export default PageNotFound;
